import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["idInput", "swatch", "wrapper", "hint"];
  async connect() {
    this.currentValue = parseInt(this.idInputTarget.value);
    this.swatchListeners = [];

    this.swatchTargets.forEach((target) => {
      const id = target.getAttribute("data-id");
      const handler = () => this.chooseColor(target);
      target.addEventListener("click", handler);
      this.swatchListeners.push({ target, handler });
      if (id == this.currentValue) {
        this.chooseColor(target);
      }
    });
  }

  disconnect() {
    this.swatchListeners.forEach(({ target, handler }) => {
      target.removeEventListener("click", handler);
    });
  }

  chooseColor(target) {
    const color = target.getAttribute("data-color");
    const id = target.getAttribute("data-id");
    const iconBackgroundColor = target.getAttribute(
      "data-icon-background-color",
    );
    const name = target.getAttribute("data-name");
    this.idInputTarget.value = id;
    this.swatchTargets.forEach((t) => target.classList.remove("selected"));
    target.classList.add("selected");
    if (color) {
      if (this.hasHintTarget) {
        this.hintTarget.innerText = name;
      }
      this.wrapperTarget.setAttribute(
        "style",
        `--brush-color: ${color}; --brush-background-color: ${iconBackgroundColor}`,
      );
    } else {
      if (this.hasHintTarget) {
        this.hintTarget.innerText = "Pick a color";
      }
      this.wrapperTarget.setAttribute("style", null);
    }
  }
}
